class CollapsibleContent extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("button") || this.querySelector("[role='button']");
    this.content = this.button.nextElementSibling;

    this.button.addEventListener("click", () => {
      const ariaExpanded = this.button.getAttribute("aria-expanded");
      if (ariaExpanded === "true") {
        this.button.setAttribute("aria-expanded", "false");
        this.content.setAttribute("aria-hidden", "true");
      } else {
        this.button.setAttribute("aria-expanded", "true");
        this.content.setAttribute("aria-hidden", "false");
      }
    });
  }
  close() {
    this.button.setAttribute("aria-expanded", "false");
    this.content.setAttribute("aria-hidden", "true");
  }

  open() {
    this.button.setAttribute("aria-expanded", "true");
    this.content.setAttribute("aria-hidden", "false");
  }
}

customElements.define("collapsible-content", CollapsibleContent);


class CollapsibleAccordions extends HTMLElement {
  connectedCallback() {
    this.collapsibleContents = this.querySelectorAll("collapsible-content");

    this.collapsibleContents.forEach((content) => {
      content.button.addEventListener("click", () => {
        this.collapsibleContents.forEach((otherContent) => {
          if (otherContent !== content) {
            otherContent.close();
          }
        });
      });
    });
  }
}

customElements.define("collapsible-accordions", CollapsibleAccordions);